import { render, staticRenderFns } from "./goodsReview.vue?vue&type=template&id=8cec9d9e&"
import script from "./goodsReview.vue?vue&type=script&lang=js&"
export * from "./goodsReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports